import SkillDetails from './src/main';

/* istanbul ignore next */
SkillDetails.install = function(Vue) {
  Vue.component(SkillDetails.name, SkillDetails);
};

export default SkillDetails;
